// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__T6QhO","logo":"Navbar_logo__2e8Iv","links":"Navbar_links__t6tyG","link":"Navbar_link__A11CC","active":"Navbar_active__voVsU"};